import { VoidFunctionComponent } from "react";
import styles from "./NavDropdown.module.scss";
import { NavDropdownProps } from "./NavDropdown.props";
import classNames from "classnames";
import Icon from "../../../../brand/Icon";

/**
 * The navigation item dropdown arrow component.
 */
export const NavDropdown: VoidFunctionComponent<NavDropdownProps> = (props: NavDropdownProps): JSX.Element => {
  const { className } = props;
  const navDropdownClasses = classNames("nav-dropdown", styles.navDropdown, className);

  return (
    <div className={navDropdownClasses}>
      <Icon id="nav-down-arrow" name={"carat-down"} />
    </div>
  );
};
